<app-header-search-link
  icon="document"
  [title]="item()['title']"
  [subtitle]="('header.search.types.' + type() | translate) + (item()['category'] ? ' - ' + item()['category'] : '')"
  [chevron]="isExpanded() ? 'up' : 'down'"
  [countries]="addOnCountries()"
  (clicked)="toggleExpanded()"
>
  @if (isExpanded()) {
    <div class="item-content">
      @switch (type()) {
        @case ('faq') {
          <app-question-content [answer]="item()['answer']" />
        }
        @case ('helpItem') {
          <app-most-relevant-item-short [item]="helpItem()" [countryFilter]="countryFilter()" />
        }
      }
    </div>
  }
</app-header-search-link>
